export enum Mode {
    student = "student",
    teacher = "teacher",
    llm = "llm",
    admin= "admin"
}